import { getCountryCode, getEffectiveBrowserLocale } from 'pricing-pages-ui-components/utils/localeUtils';

/* Local mirror of pricing-pages-api's CountryCode (kept local to avoid that
   import): the generated union minus the UNDEFINED sentinel and the
   unhandledEnumCase symbol, so it matches the CountryCode the RPC variables
   expect. */

/* Inlined country-code guard. Narrows the shared getCountryCode() string to the
   CHIRP CountryCode that RPC params expect, so call sites pass
   preferredCountryCode without a cast. */
function isCountryCode(value) {
  return typeof value === 'string' && value !== 'UNDEFINED';
}
export const getBrowserLocale = () => {
  const rawCountryCode = getCountryCode();
  const preferredCountryCode = isCountryCode(rawCountryCode) ? rawCountryCode : undefined;
  return {
    browserLocale: getEffectiveBrowserLocale(),
    preferredCountryCode
  };
};